module.exports = __webpack_public_path__ + "img/Car_haul.617032b.png";